export default "__VITE_ASSET__Z9hoAkXG__"